import { createFileRoute } from "@tanstack/react-router";
import { RedirectPage } from "components/UI/RedirectPage/RedirectPage";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout")({
    component: AdvertiserRequestsPage,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.advertiser.request.title"),
        };
    },
});

function AdvertiserRequestsPage() {
    return <RedirectPage />;
}
